import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import { TextField } from "@mui/material";
import { Redirect } from "react-router-dom";
import { useFormik } from "formik";
import axios from "../../../utils/http";
import { LOGIN } from "../../../utils/urls";
import jwt_decode from "jwt-decode";
import "./style.css";
import logo from "../../../utils/assests/logo.png";
import Loader from "../../../Common/Loader";
import Box from "@mui/material/Box";
import "../../../App.scss";


import './style.css'
// import logo from '../../../utils/assests/logo.png'
export interface DecodedJwtToken {
  exp: number;
}

export default function Login() {
  const [login, setLogin] = useState(false);
  const [error, setError] = useState("");
  const [loader, setLoader] = useState(false);

  const validate = (values: any) => {
    const errors: any = {};

    if (!values.userId) {
      errors.userId = "User ID Required";
    }

    setError("");

    if (!values.password) {
      errors.password = "User Password Required";
    }

    return errors;
  };

  const formik = useFormik({
    initialValues: {
      userId: "",
      password: "",
    },
    validate,
    onSubmit: (values) => {
      setLoader(true);

      axios
        .post(LOGIN, {
          username: values.userId,
          password: values.password,
        })
        .then((res) => {
          setLoader(false);
          const decodedJwtToken: DecodedJwtToken = jwt_decode(
            res.data.results.access_token
          );
          localStorage.setItem("expireIn", decodedJwtToken.exp.toString());
          localStorage.setItem("authToken", res.data.results.access_token);
          localStorage.setItem("refreshToken", res.data.results.refresh_token);
          setLogin(res.data.status);
        })
        .catch((e) => {
          setLoader(false);
          setError(e.response?.data?.errors?.detail);
        });
    },
  });

  return loader ? (
    <Loader loading={true} />
  ) : (
    <Box component="div" sx={{ mt: 7 }} className="loginPage">
      <div className="newCard">
        <div id="logo" className="text-center">
          <img src={logo} alt="Stashfin" />
        </div>

        <form onSubmit={formik.handleSubmit}>
          {login ? <Redirect to="/dashboard" /> : ""}
          <div>
            <h3>Log In</h3>
            <p color="text.secondary">Enter your registered User ID</p>
          </div>

          {formik.errors ? (
            <h6 className="errorMsg">
              {formik.errors?.userId || formik.errors?.password}
              {/* {Object.entries(formik.errors)[0]} */}
            </h6>
          ) : (
            ""
          )}
          {error ? (
            <h3 style={{ color: "red", textAlign: "center" }}>{error}</h3>
          ) : (
            ""
          )}

          <div id="main">
            <div id="stick"></div>

            <div id="card">
              <Box sx={{ mb: 2 }}>
                <Box sx={{ mb: 1 }}>
                  <label>User Id</label>
                </Box>
                <TextField
                  id="outlined-basic"
                  className="input"
                  name="userId"
                  onChange={formik.handleChange}
                  fullWidth
                />
              </Box>

              <Box sx={{ mb: 2 }}>
                <Box sx={{ mb: 1 }}>
                  <label>Password</label>
                </Box>
                <TextField
                  type="password"
                  id="outlined-basic"
                  className="input"
                  name="password"
                  onChange={formik.handleChange}
                  fullWidth
                />
              </Box>
            </div>
          </div>

          <Box sx={{ mt: 5, textAlign: "center" }} id="buttonId">
            {/* <button id="buttonSID" type="submit" onClick={handleClick}>Login</button> */}
            <button id="buttonSID" type="submit">
              Login
            </button>
          </Box>
        </form>
      </div>
    </Box>
  );
}
